import { type TeamMemberAddInput, toResponseError, type ResponseSuccess } from '@terros/common'
import { applyRoleIdChange } from '../user/listRoles'
import { useUserCache } from '../user'
import { useTeamCache } from '../team'
import { useRoleCache } from '../role'
import { useTantalimMutation } from '../mutation'
import { type AddHookResponse, mutationAdd } from '../hooks'

export function useAddTeamMember(): AddHookResponse<TeamMemberAddInput, ResponseSuccess> {
  const cache = useTeamCache()
  const userCache = useUserCache()
  const roleCache = useRoleCache()
  const mutation = useTantalimMutation<TeamMemberAddInput, ResponseSuccess>({ url: '/team/member/add' })

  async function add(input: TeamMemberAddInput): Promise<ResponseSuccess> {
    try {
      const output = await mutation.mutateAsync(input)
      cache.updateMembership(input)
      const user = userCache.getItem(input.userId)
      if (user) {
        user.teams?.directMemberOf.forEach((team) => {
          cache.clearItem(team.teamId)
        })
        userCache.clearItem(input.userId)
      }
      userCache.syncListedRoles(input.userId, (roles) =>
        applyRoleIdChange({
          roles,
          nextRoleIds: input.roleIds,
          resolveRole: roleCache.findTinyRole,
        })
      )
      return output
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationAdd(mutation, add)
}
